<template>
    <div class="loc-1">
        <div class="map_container1">
            <div id="container" style="width: 100%; height: 700px"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        formData: {},
    },
    data() {
        return { map: null, markers: [], data: {} }
    },
    async mounted() {
        await this.loadMap()
    },
    created() {
        this.loadMap()
    },
    watch: {
        formData: {
            handler(val) {
                console.log(val)
                if (this.formData.id) {
                    this.renderMapMarker(val)
                }
                if (val.hide) {
                    this.data = { latitude: "", longitude: "" }
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        loadMap() {
            return new Promise((resolve, reject) => {
                this.map = new AMap.Map("container", {
                    resizeEnable: true,
                    zoom: 9,
                })
                resolve()
            })
        },
        renderMapMarker(val) {
            console.log(val)
            this.map.remove(this.markers)
            this.markers = []
            let self = this
            var endIcon = new AMap.Icon({
                size: new AMap.Size(49, 56),
                image: require("./img/end_icon.png"),
                imageSize: new AMap.Size(38, 42),
            })
            // console.log(val.longitude, val.latitude, 'aaaaaa')
            let marker = new AMap.Marker({
                position: [val.longitude, val.latitude],
                icon: endIcon,
            })
            self.markers.push(marker)
            self.map.add(self.markers)
            self.map.setFitView(self.markers)
        },
    },
}
</script>

<style lang="less" scoped>
.loc-1 {
    width: 98%;
    margin-left: 2%;
}
</style>
